import { render, staticRenderFns } from "./TrainingsPage.vue?vue&type=template&id=a9f3deea&"
import script from "./TrainingsPage.vue?vue&type=script&lang=js&"
export * from "./TrainingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports